import React from "react";
import { $, merge } from "glamor";
import classNames from "classnames";

const styles = merge(
    {
        width: "150px",
        height: "100%",
        overflow: "hidden",
        position: "absolute",
        top: "0px",
        right: "0px",
        pointerEvents: "none",
    },
    $(".bannerSmall", {
        width: "100px",
    }),
    $(" .banner", {
        width: "150px",
        height: "30px",
        overflow: "hidden",
        position: "absolute",
        top: "20px",
        right: "-36px",
        opacity: 0.85,
        transform: "rotate(45deg)",
        textAlign: "center",
    }),
    $(" .banner.bottom", {
        top: "auto",
        bottom: "20px",
        transform: "rotate(-45deg)",
    }),
    $(".bannerSmall .banner", {
        top: "18px",
        right: "-40px",
    }),
    $(".bannerSmall .banner.bottom", {
        top: "auto",
        bottom: "18px",
    }),
    $(".colorWayBanner", {
        width: "100%",
    }),
    $(".colorWayBanner .banner", {
        top: "auto",
        bottom: "15px",
        right: "-20px",
        height: "10px",
        width: "100%",
    }),
    $(" .bannerInner", {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "-webkit-box",
        width: "100px",
        lineHeight: "12px",
        maxHeight: "24px",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        verticalAlign: "middle",
        fontSize: "10px",
    }),
    $(".bannerSmall .bannerInner", {
        width: "80px",
    })
);

export default function Banner({ item, banner = null, small = false, scope, isColorWay = false }) {
    const itemBanner = banner || (item ? item.getBanner(scope) : null);

    if (itemBanner) {
        const bannerStyle = {
            backgroundColor: `#${itemBanner.background_color}`,
            color: `#${itemBanner.foreground_color}`,
        };
        return (
            <div {...styles} className={classNames({ bannerSmall: small, colorWayBanner: isColorWay })}>
                <div className={classNames("banner", { bottom: itemBanner.bottom })} style={bannerStyle}>
                    <div className="bannerInner">{itemBanner.name}</div>
                </div>
            </div>
        );
    }
    return null;
}
